<template>
  <div>
    <div class="text-h6">Topic</div>
    <v-btn
      text
      class="pl-0 mt-4"
      @click="back"
    >
      &lt; Back
    </v-btn>
    <v-row>
      <v-col
        cols="12"
        md="3"
      >
        <EditTopic />
      </v-col>
      <v-col
        cols="12"
        md="9"
      >
        <Templates
          v-if="!loading"
          show-title
        />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import EditTopic from '@/components/topics/Edit';
import Templates from '@/components/catalog/Templates';

export default {
  name: 'TopicDetail',

  components: {
    EditTopic,
    Templates
  },

  data() {
    return { loading: true };
  },

  computed: {
    id() {
      return this.$route.params.id;
    }
  },
  mounted() {
    this.loading = true;
    Promise.all([
      this.$store.dispatch('topics/get', this.id),
      this.$store.dispatch('lookup/getCategories'),
      this.$store.dispatch('catalog/filter', { topicId: this.id, page: 1 })
    ])
      .catch((error) => {
        this.logError(error);
      })
      .finally(() => {
        this.loading = false;
      });
  }
};
</script>
